import { formatCPF } from '@brazilian-utils/brazilian-utils'
import { Flex, Box, Text, Avatar } from '@chakra-ui/react'
import { Row, Col } from 'antd'
import colors from 'core/resources/theme/colors'
import { formatPhone } from 'infra/helpers/number'

const TituloItem = ({ titulo }: { titulo: string }) => (
  <Text as="h4" color={colors.black500} textTransform="uppercase" fontSize={14}>
    {titulo}
  </Text>
)

const TextoItem = ({ texto }: { texto: string }) => (
  <Text fontSize={15} color={colors.black} fontWeight="medium">
    {texto}
  </Text>
)

const ItemInfo = ({ titulo, texto }: { titulo: string; texto: string }) => (
  <Flex flexDir="column">
    <TituloItem titulo={titulo} />
    <TextoItem texto={texto} />
  </Flex>
)

export const PessoaInfo = ({
  titulo,
  nome,
  imagemUrl,
  celular,
  email,
  documento,
  subtitulo
}: {
  titulo: string
  nome: string
  celular: string
  email: string
  documento: string
  imagemUrl?: string | null
  subtitulo?: string
}) => (
  <>
    <Flex flexDir="column" w="100%">
      <Text fontSize={21} mb={3}>
        {titulo}
      </Text>

      <Flex w="100%" flexDir="column">
        <Flex display="flex" flexDir="row" gridGap={3} mb={2}>
          <Avatar src={imagemUrl || undefined} name={nome} />
          <Flex flexDir="column">
            <Text fontSize={16} fontWeight="semibold" color={colors.black900}>
              {nome}
            </Text>
            <Text fontSize={16} fontWeight="light">
              {subtitulo}
            </Text>
          </Flex>
        </Flex>
        <Box>
          <Box>
            <Box as={Row} gutter={12}>
              <Box as={Col} sm={6}>
                <ItemInfo titulo="Celular:" texto={formatPhone(celular)} />
              </Box>
              <Box as={Col} sm={5}>
                <ItemInfo titulo="CPF:" texto={formatCPF(documento)} />
              </Box>
              <Box as={Col} sm={11}>
                <ItemInfo titulo="Email" texto={email} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Flex>
    </Flex>
  </>
)
